import React from 'react';

interface Props {
  user: {
    _id: string;
    username: string;
    role: string;
    email: string;
    employedSince?: string;
  };
  onEdit: () => void;
  onDelete: () => void;
}

const UserItem: React.FC<Props> = ({ user, onEdit, onDelete }) => {
  return (
    <div className="card mb-3 shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-2">{user.username} <small className="text-muted">({user.role})</small></h5>
        <p className="card-text mb-3">{user.email}</p>
        {user.employedSince && (
          <p className="card-text text-muted mb-3">
            Beschäftigt seit: {new Date(user.employedSince).toLocaleDateString('de-DE')}
          </p>
        )}
        <div className="d-flex justify-content-end gap-2">
          <button className="btn btn-outline-primary btn-sm" onClick={onEdit}>✏️ Bearbeiten</button>
          <button className="btn btn-outline-danger btn-sm" onClick={onDelete}>🗑️ Löschen</button>
        </div>
      </div>
    </div>
  );
};

export default UserItem;
